import { filterEntitiesBy } from "actions/entities";
import React from 'react'
import { connect } from 'react-redux'
import { Menu } from "semantic-ui-react";
import { FormGroup } from "semantic-ui-react";
import { Form } from "semantic-ui-react";
import { Dropdown } from "semantic-ui-react";
import { Input } from "semantic-ui-react";
import ui from "../../redux-ui";

var n = 0

class FilterBar extends React.Component {

  componentWillUnmount() {
    this.props.filters && this.removeFilters(this.props.filters)
  }

  setFilter = (by) => (event, props) => {
    this.props.filterEntities(by, props.value);
  };

  removeFilters = (filters)  => {
    filters.forEach((filter) => {
      this.props.filterEntities(filter.by, null);
    })
  }

  renderFilterBar = () => {
    const { filters } = this.props;
    return (<Form className={"filterbar-form"}>
      <FormGroup>
        {filters.map((filter) => {
          if (filter.selectOptions) {
            // Render dropdown
            return (
              <Form.Field key={`${filter.by}-filter`}>
                <Dropdown className={"filterbar-dropdown"}
                  placeholder={I18n.t(`components.filters.${filter.by}`)}
                  multiple
                  search
                  selection
                  options={filter.selectOptions}
                  onChange={this.setFilter(filter.by)}
                />
              </Form.Field>
            );
          }

          // Render input
          return (
            <Form.Field key={`${filter.by}-filter`}>
              <Input className={"filterbar-input"}
                placeholder={I18n.t(`components.filters.${filter.by}`)}
                onChange={this.setFilter(filter.by)}
                icon={'search'}
              />
            </Form.Field>
          );
        })}
      </FormGroup>
    </Form>)
  }



  render() {
    const { filters } = this.props;

    if(!filters) return null;

    if(this.props.ui.showFilters) {
      return (
        <Menu.Item active className="filterbar-no-padding">
          {this.renderFilterBar()}
          <Menu.Item icon={'close'} onClick={() => { this.props.updateUI('showFilters', false); this.removeFilters(filters)}} className="filterbar-no-margin"/>
        </Menu.Item>)
    } else {
      return (<Menu.Item icon={'filter'} onClick={() => this.props.updateUI('showFilters', true)}/>)
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const entitiesName = (ownProps.entitiesName);
  return {
    filterEntities: (by, value) => {
      dispatch(filterEntitiesBy(entitiesName, by, value));
    },
  };
};

export default (ui({ state: { showFilters: false } })(connect(null, mapDispatchToProps)(FilterBar)));

